import Vue from 'vue'
import Router from 'vue-router'
import Login from "./components/Login/Login.vue";
import Registration from "./components/Registration/Registration.vue";
import { isPublicRegistrationEnabled } from './utils/RegistrationForm';
import DeviceList from "./components/DeviceList/DeviceList.vue";
import DeviceGroupActions from "./components/DeviceList/DeviceGroupActions.vue";
import SavedConfigurationList from "./components/SavedConfigurationList/SavedConfigurationList.vue";
import Device from "./components/Device/Device.vue";
import DeviceFirmware from "./components/DeviceSettings/Firmware.vue";
import SavedConfiguration from "./components/SavedConfig/SavedConfig.vue";
import FirmwareList from "./components/FirmwareList/FirmwareList.vue";
import OrganisationList from "./components/OrganisationList/OrganisationList.vue";
import UserList from "./components/UserList/UserList.vue";
import UserInfo from "./components/UserList/Info.vue";
import store from './store.js'
import {loadLanguageAsync} from './i18n.ts'
import DeviceRegister from "./components/Device/DeviceRegister";
import Monitoring from "@/client/components/Monitoring/Monitoring";
import DeviceGroups from "./components/Monitoring/DeviceGroups";
import DeviceHistory from "./components/Monitoring/DeviceHistory/DeviceHistory";
import Messages from "./components/Monitoring/Messages/Messages";
import DeviceProps from "./components/Monitoring/DeviceProps/DeviceProps";

Vue.use(Router);

let router = new Router({
    base: "/",
    routes: [
        {
            path: "/",
            component: DeviceList,
            props: true
        },
        {
            path: "/devices",
            component: DeviceList,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/devicesGroupActions",
            component: DeviceGroupActions,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/devicesGroupActions?customIdOrImeiListRaw=:customIdOrImeiListRaw",
            component: DeviceGroupActions,
            props: true,
            meta: {
                requiresAuth: true
            },
            name: "deviceCustomIdOrImeiList"
        },
        {
            path: "/device/:id",
            component: Device,
            props: true,
            meta: {
                requiresAuth: true
            },
            name: "device"
        },
        {
            path: "/device/:id/section/:section",
            component: Device,
            props: true,
            meta: {
                requiresAuth: true
            },
            name: "deviceSection"
        },
        {
            path: "/device/:id/firmware",
            component: DeviceFirmware,
            props: true,
            meta: {
                requiresAuth: true
            },
            name: "deviceFirmware"
        },
        {
            path: "/saved-configurations",
            component: SavedConfigurationList,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/saved-configurations/:id",
            component: SavedConfiguration,
            props: true,
            meta: {
                requiresAuth: true
            },
            name: "savedConfiguration"
        },
        {
            path: "/users",
            component: UserList,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/organisations",
            component: OrganisationList,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/user-info",
            component: UserInfo,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/firmwares",
            component: FirmwareList,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/device-register",
            component: DeviceRegister,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/registration',
            name: 'Registration',
            component: Registration,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/monitoring',
            name: 'monitoring',
            component: Monitoring
        },
        {
            path: '/history/:deviceId?',
            name: 'history',
            component: DeviceHistory
        },
        {
            path: '/device-groups',
            name: 'device-groups',
            component: DeviceGroups
        },
        {
            path: '/messages/:deviceId?',
            name: 'mesasges',
            component: Messages
        },
        {
            path: '/device-props/:deviceId?',
            name: 'device-props',
            component: DeviceProps
        },
    ]
});

router.beforeEach(async (to, from, next) => {
    if (to.name === 'Registration' && !isPublicRegistrationEnabled()) {
        next('/login');
        return;
    }
    if (to.matched.some(record => record.meta.requiresAuth) && !store.getters.isLoggedIn) {
        next('/login');
        return;
    }

    try {
        await loadLanguageAsync(store.getters.getLang);
    } catch (error) {
        next(error);
        return;
    }
    next();
});

export default router
